import { useState } from "react";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import Reveal from "./Reveal";
import BookingCTA from "./BookingCTA";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PaymentCTA = () => {
  const [loadingCustom, setLoadingCustom] = useState(false);
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");

  const pay = async (lookupKey, quantity, setLoading) => {
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/payments/checkout`, {
        lookup_key: lookupKey,
        quantity,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      setError(e.response?.data?.detail || "Impossible de créer le paiement. Réessayez.");
      setLoading(false);
    }
  };

  const payCustom = () => {
    const dollars = parseInt(amount, 10);
    if (!dollars || dollars < 10 || dollars > 10000) {
      setError("Indiquez un montant entre 10 $ et 10 000 $ CA.");
      return;
    }
    pay("paiement_libre_eur", dollars, setLoadingCustom);
  };

  return (
    <Reveal delay={0.15}>
      <div
        className="mt-16 rounded-2xl border border-blue-500/25 bg-gradient-to-br from-[#111115] to-[#0d1220] p-6 sm:p-10"
        data-testid="payment-section"
      >
        <div className="flex flex-col lg:flex-row lg:items-start gap-10">
          <BookingCTA />

          <div className="hidden lg:block w-px self-stretch bg-white/10" />

          <div className="lg:w-[38%] shrink-0">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500 mb-3">Paiement libre</p>
            <h3 className="font-display font-semibold text-xl tracking-tight mb-3">Régler une facture</h3>
            <p className="text-zinc-400 text-sm leading-relaxed mb-5">
              Vous avez déjà un devis ? Saisissez le montant convenu et payez en toute sécurité.
            </p>
            <div className="flex gap-3">
              <div className="relative flex-1">
                <input
                  type="number"
                  min="10"
                  max="10000"
                  placeholder="Montant en $ CA"
                  value={amount}
                  onChange={(e) => {
                    setAmount(e.target.value);
                    setError("");
                  }}
                  className="w-full bg-[#08080a] border border-white/10 rounded-full px-5 py-3.5 text-sm text-white placeholder:text-zinc-600 outline-none focus:border-blue-500 transition-colors duration-300"
                  data-testid="custom-amount-input"
                />
                <span className="absolute right-5 top-1/2 -translate-y-1/2 text-zinc-500 text-sm">$</span>
              </div>
              <button
                onClick={payCustom}
                disabled={loadingCustom}
                className="flex items-center gap-2 border border-blue-500/50 hover:bg-blue-500 disabled:opacity-60 text-white font-semibold px-6 py-3.5 rounded-full transition-colors duration-300 whitespace-nowrap"
                data-testid="pay-custom-button"
              >
                {loadingCustom ? <Loader2 size={18} className="animate-spin" /> : "Payer"}
              </button>
            </div>
          </div>
        </div>

        {error && (
          <p className="text-red-400 text-sm mt-5" data-testid="payment-error">
            {error}
          </p>
        )}
        <p className="flex items-center gap-2 text-xs text-zinc-600 mt-6 font-mono">
          <Lock size={12} /> Paiement chiffré et sécurisé via Stripe — Visa, Mastercard, Apple Pay
        </p>
      </div>
    </Reveal>
  );
};

export default PaymentCTA;
